var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadToCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50008 1.72461C9.24267 1.72461 10.6943 2.93554 11.0202 4.54124C12.2612 4.62757 13.2433 5.62571 13.2433 6.85763C13.2433 8.14602 12.1717 9.19083 10.8503 9.19083H4.62846C3.04237 9.19083 1.75684 7.93743 1.75684 6.39099C1.75684 4.94722 2.8782 3.75915 4.31832 3.60796C4.91706 2.48943 6.11596 1.72461 7.50008 1.72461ZM9.485 5.52593L7.50071 3.59124L5.51594 5.52593C5.36518 5.67292 5.47239 5.92444 5.68537 5.92444H6.54351V7.55767C6.54351 7.68646 6.65071 7.79099 6.78281 7.79099H8.21862C8.35071 7.79099 8.45792 7.68646 8.45792 7.55767V5.92444H9.31606C9.52904 5.92444 9.63576 5.67292 9.485 5.52593Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadToCloud);
export default __webpack_public_path__ + "static/media/upload-to-cloud.f1fcbd783aa9c08708791325d3d3898f.svg";
export { ForwardRef as ReactComponent };